import React, { useEffect, useState, useRef } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { addISBNDashes, showHelp } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";


export default function SetupTaxCodesNew(props) {

    const { controller = "", group = { customer_code : "", description : "", tax_code_1 : "", tax_code_2 : "", tax_code_b : "", tax_code_3 : ""}, edit = false, groups = [], types = [], route = "", callback = () => { }, signal = {}, employee = false } = props;

    const codes = types.map(item => { return { label: item.code, value: item.code } });

    const refs = useRef([]);

    const [index, setIndex] = useState("customer_code");

    const [tabs, setTabs] = useState([
        { key: "customer_code", value: group.customer_code },
        { key: "description", value: group.description },
        { key: "tax_code_1", value: group.tax_code_1 },
        { key: "tax_code_2", value: group.tax_code_2 },
        { key: "tax_code_b", value: group.tax_code_b },
        { key: "tax_code_3", value: group.tax_code_3 },
    ])

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const status = {
        customer_code: <>PgUp for Help</>,
        description: <>PgUp for Help</>,
        tax_code_1: <>PgUp for Help</>,
        tax_code_2: <>PgUp for Help</>,
        tax_code_b: <>PgUp for Help</>,
        tax_code_3: <>PgUp for Help</>,
    }

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });

    const next = () => {
        if (employee) { return; }
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        if (employee) { return; }
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const onEnter = () => {
        switch (index) {
            case "tax_code_1":
            case "tax_code_2":
            case "tax_code_b":
            case "tax_code_3":
                let _v = getVal(index);
                let _c = codes.map(item => item.value);
                _v = (_c.includes(_v)) ? _v : _c[0];
                drawPicker({
                    controller : controller,
                    value: _v, ref: refs.current[index], route: route, callback: (e) => update(index, e), offset: [0, 10],
                    options: codes
                })
                break;
        }
    }

    const onPageUp = () => {
        switch (index) {
            case "customer_code":
                refs.current[index].blur();
                showHelp({ callback: () => { refs.current[index].focus(); }, width: 400, route: route, title: "Customer Tax Code: ", component: <small>The one to four character code entered here is linked with Customer file tax code field so that customers in different tax regions may be taxed accordingly.</small> });
                break;

            case "description":
                refs.current[index].blur();
                showHelp({ callback: () => { refs.current[index].focus(); }, width: 250, route: route, title: "Description", component: <small>A descriptive name for this tax code.  </small> });
                break;
            case "tax_code_1":
            case "tax_code_2":
            case "tax_code_b":
            case "tax_code_3":
                refs.current[index].blur();
                showHelp({ callback: () => { refs.current[index].focus(); }, width: 550, route: route, title: "Tax to Apply", component: <small>Enter up to two letters that correspond to the required tax(es) listed in the Tax Names/Rates table.<div className="shim" /><div className="shim" />Each product in Inventory is linked to a Classification (F4 file) and each Class is assigned one of five possible tax codes ( 12B3). <div className="shim" /><div className="shim" />If a product's tax code is 1 and this type of customer is to be charged tax 'a' (from the Tax Names/Rates table), enter 'a'. If there is no tax, leave the field blank.</small> });
                break;
        }
    }


    const validateGroups = (_taxgroup) => {
        let _str = _taxgroup.tax_code_1 + _taxgroup.tax_code_2 + _taxgroup.tax_code_b + _taxgroup.tax_code_3;
        let _arr = _str.split("");
        let _c = codes.map(item => item.value);
        let _valid = true;  
        _arr.forEach(element => {
            if(!_c.includes(element)){
                _valid = false; 
            }
        });
        return _valid;
    }

    const save = () => {

        let _taxgroup = {
            customer_code: getVal("customer_code"),
            description: getVal("description"),
            tax_code_1: getVal("tax_code_1"),
            tax_code_2: getVal("tax_code_2"),
            tax_code_b: getVal("tax_code_b"),
            tax_code_3: getVal("tax_code_3"),
        }

        if(!validateGroups(_taxgroup)){
            showError({error : "Contains invalid tax codes"})
            return; 
        }

        let _api = (edit) ? "setting.tax.editGroup" : "setting.tax.createGroup";
        let _obj = (edit) ? { original_code : group.customer_code, info : _taxgroup} : { info : _taxgroup}; 

        pubCall(_api, _obj, (_s, _r) => {
            if (_s) {
                callback(_r);
            } else {
                showError(_r);
            }
        })

    }

    // Keyboard Events
    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            { key: KBD.ENTER, action: (e) => { onEnter() } },
            { key: KBD.PAGE_UP, action: (e) => { onPageUp() } },
            { key: KBD.PAGE_DOWN, action: (e) => { save() } }
        ];
        const cleanup = listen(controller, route, actions, (e) => {
            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [index, tabs, update]);


    return (<>
        <div className="shim" /><div className="shim" /><div className="shim" />
        <div style={{ "width": "320px" }}>
            <Space height={25} size={10}>
                <Label width={100}>Customer Code</Label><Divider vertical />
                <Input {...editProps("customer_code")} uppercase maxLength={4} autoselect placeholder="" width={80} value={getVal("customer_code")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Description</Label><Divider vertical />
                <Input {...editProps("description")} maxLength={11} autoselect placeholder="" width={180} value={getVal("description")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Tax code 1</Label><Divider vertical />
                <Input doubleclick={KBD.ENTER} {...editProps("tax_code_1")} lowercase maxLength={2} autoselect placeholder="" width={40} value={getVal("tax_code_1")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Tax code 2</Label><Divider vertical />
                <Input doubleclick={KBD.ENTER} {...editProps("tax_code_2")} lowercase maxLength={2} autoselect placeholder="" width={40} value={getVal("tax_code_2")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Tax code B</Label><Divider vertical />
                <Input doubleclick={KBD.ENTER} {...editProps("tax_code_b")} lowercase maxLength={2} autoselect placeholder="" width={40} value={getVal("tax_code_b")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Tax code 3</Label><Divider vertical />
                <Input doubleclick={KBD.ENTER} {...editProps("tax_code_3")} lowercase maxLength={2} autoselect placeholder="" width={40} value={getVal("tax_code_3")} />
            </Space>
            <div className="shim" />
            <div className="shim" />
            <div style={{ "textAlign": "center" }}><small className="label">Press <strong>{KBD.PAGE_DOWN.label}</strong> to save.</small></div>
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon /> {status[index]}</Status>
        </div>

    </>)

}